<ng-template #contextMenu let-data>
    <section class="card-menu mat-elevation-z20" [style.color]="'white'" [style.padding]="'10px'"
             [style.background]="'rgb(66, 66, 66)'" [style.border-radius]="'2px'">
        <button mat-button (click)="clicked.emit(data)">
            <mat-icon *ngIf="icon">{{icon}}</mat-icon>
            {{label}}
        </button>
    </section>
</ng-template>
